import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Seo from "./components/site/Seo";
import SiteHeader from "./components/site/SiteHeader";
import SiteFooter from "./components/site/SiteFooter";
import SmoothScroll from "./components/site/SmoothScroll";
import Preloader from "./components/site/Preloader";

import Home from "./pages/Home";
import MasterPlan from "./pages/MasterPlan";
import InventoryPage from "./pages/InventoryPage";
import Stages from "./pages/Stages";
import StageDetail from "./pages/StageDetail";
import Videos from "./pages/Videos";
import Builders from "./pages/Builders";
import BuilderDetail from "./pages/BuilderDetail";
import SectionPage from "./pages/SectionPage";
import Location from "./pages/Location";
import Community from "./pages/Community";
import CommunityBusinesses from "./pages/CommunityBusinesses";
import CommunityParks from "./pages/CommunityParks";
import CommunityGettingAround from "./pages/CommunityGettingAround";
import History from "./pages/History";
import Contact from "./pages/Contact";
import SeoLanding from "./pages/SeoLanding";
import Login from "./pages/Login";
import InvestorPortal from "./pages/InvestorPortal";
import AdminApp from "./pages/admin/AdminApp";

const CHROMELESS = ["/login", "/admin"];

const Shell = ({ children }) => {
  const loc = useLocation();
  const bare = CHROMELESS.some((p) => loc.pathname.startsWith(p));
  if (bare)
    return (
      <>
        <Seo />
        {children}
      </>
    );
  return (
    <>
      <Seo />
      <Preloader />
      <SmoothScroll />
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-center" richColors />
            <Shell>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/master-plan" element={<MasterPlan />} />
              <Route path="/available-land" element={<InventoryPage mode="available" />} />
              <Route path="/sold-reserved" element={<InventoryPage mode="sold" />} />
              <Route path="/stages" element={<Stages />} />
              <Route path="/stages/:id" element={<StageDetail />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/builders" element={<Builders />} />
              <Route path="/builders/:id" element={<BuilderDetail />} />
              <Route
                path="/commercial"
                element={<SectionPage sectionKey="commercial" landUse="commercial" fallbackTitle="Commercial Centre" fallbackIntro="A secured commercial centre planned as a key driver of long-term value for Deer Park Estates." />}
              />
              <Route
                path="/apartment"
                element={<SectionPage sectionKey="apartment" landUse="apartment" fallbackTitle="Apartment Project" fallbackIntro="A planned multi-family apartment project expanding the community's housing mix." />}
              />
              <Route path="/location" element={<Location />} />
              <Route path="/community" element={<Community />} />
              <Route path="/community/local-businesses" element={<CommunityBusinesses />} />
              <Route path="/community/parks-and-amenities" element={<CommunityParks />} />
              <Route path="/community/getting-around" element={<CommunityGettingAround />} />
              <Route path="/about" element={<History />} />
              <Route path="/history" element={<Navigate to="/about" replace />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/new-homes-edmonton" element={<SeoLanding />} />
              <Route path="/lots-for-sale-spruce-grove" element={<SeoLanding />} />
              <Route path="/build-your-home-alberta" element={<SeoLanding />} />
              <Route path="/login" element={<Login />} />
              <Route path="/portal" element={<InvestorPortal />} />
              <Route path="/admin" element={<AdminApp />} />
            </Routes>
            </Shell>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
